import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import './dashboard/dashboard.scss';

class Welcome extends Component {
	constructor(props) {
		super(props);

		this.quickLinks = [
			{href: '/v2/admin/dashboard', name: 'Dashboard'},
			{href: '/v2/admin/bid-center/merch-ed-overview', name: 'Merchant Overview'},
			{href: '/v2/admin/bid-center/publisher-overview', name: 'Publisher Overview'},
			{href: '/v2/admin/accounts/all', name: 'Manage Accounts'},
			{href: '/v2/admin/article-search', name: 'Search for articles'},
			{href: '/v2/admin/smartlinks/editor', name: 'Smartlink Editor'},
			{href: '/v2/admin/bid-center/bulk-match', name: 'Bulk Match Page'},
			{href: '/v2/admin/feed-comparison', name: 'Feed Comparison'},
		];

		this.state = {
			smartlinkId: null,
		};
	}

	goToBidPage(e) {
		e.preventDefault();
		window.location = `/#/admin/smartlinks/${this.state.smartlinkId}`;
	}

	render() {
		const quickLinks = this.quickLinks.map((link, idx) => {
			return <Link key={idx} to={link.href}>{link.name}</Link>;
		});

		return (
			<div className="admin-index">
				<h1>WELCOME TO NARRATIV!</h1>
				<div className="quick-links">
					{quickLinks}
				</div>
				<form className="bidpage-nav" onSubmit={this.goToBidPage.bind(this)}>
					<input
						type="text"
						value={this.state.smartlinkId || ''}
						placeholder="Enter Smartlink ID"
						onChange={(e) => this.setState({smartlinkId: e.target.value})}
					/>
					<button>View bid page</button>
				</form>
			</div>
		);
	}
}

export default Welcome;
